<template>
  <div>
    <div
      v-if="notApproved || failedValidations || failedTests || failedVirusScan"
      class="has-text margin-bottom-1"
    >
      <a
        v-if="notApproved"
        :href="item.chocoPackage.GalleryDetailsUrl"
        target="_blank"
      >
        <span class="tags has-addons is-inline margin-left-10">
          <span class="tag">Status</span>
          <span class="tag is-danger">Not approved</span>
        </span>
      </a>

      <a
        v-if="failedVirusScan"
        :href="`${item.chocoPackage.GalleryDetailsUrl}#virus`"
        target="_blank"
      >
        <span class="tags has-addons is-inline margin-left-10">
          <span class="tag">VirusTotal</span>
          <span class="tag is-danger">Flagged</span>
        </span>
      </a>

      <a
        v-if="failedValidations"
        :href="item.chocoPackage.GalleryDetailsUrl"
        target="_blank"
      >
        <span class="tags has-addons is-inline margin-left-10">
          <span class="tag">Validation</span>
          <span class="tag is-warning">
            {{ item.chocoPackage.PackageValidationResultStatus }}</span
          >
        </span>
      </a>

      <a
        v-if="failedTests"
        :href="
          item.chocoPackage.PackageTestResultUrl != ''
            ? item.chocoPackage.PackageTestResultUrl
            : item.chocoPackage.GalleryDetailsUrl
        "
        target="_blank"
      >
        <span class="tags has-addons is-inline margin-left-10">
          <span class="tag">Tests</span>
          <span class="tag is-warning">
            {{ item.chocoPackage.PackageTestResultStatus }}</span
          >
        </span>
      </a>
    </div>

    <div
      class="notification is-warning margin-bottom-1"
      v-if="hasMultipleVersions && installable"
    >
      There's multiple versions of this package already installed. Either add
      the -m parameter to install the package side-by-side, or uninstall the
      existing versions.
    </div>

    <div
      class="notification is-warning margin-bottom-1"
      v-if="isHigerVersionInstalled && installable"
    >
      This package version is lower than at least one already installed package.
      Either add the -m option to install the package side-by-side, or uninstall
      the existing versions.
    </div>    
  </div>
</template>
<script>
import checks from "@/utils/packageCheck";
import status from "@/utils/packageStatus";
import { hasParam } from "@/utils/mdc";

export default {
  props: { item: Object },
  computed: {
    hasParam() {
      return param => {
        return hasParam(this.item.tempCommand.parameters, param);
      };
    },

    isHigerVersionInstalled() {
      return status.isHigerVersionInstalled(this.item);
    },
    hasMultipleVersions() {
      return status.hasMultipleVersions(this.item);
    },
    installable() {
      return status.isInstallable(this.item);
    },
    failed() {
      return status.hasFailed(this.item);
    },
    notApproved() {
      return checks.isNotApproved(this.item);
    },
    failedValidations() {
      return checks.hasFailedValidations(this.item);
    },
    failedVirusScan() {
      return checks.hasFailedVirusScan(this.item);
    },
    failedTests() {
      return checks.hasFailedTests(this.item);
    }
  }
};
</script>
